// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickJournalCyberpunkAmbientMotion__container___X8kOW {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;
}

.QuickJournalCyberpunkAmbientMotion__ambient___QPEJj {
    position: absolute;
    inset: -18%;
    filter: blur(54px);
    mix-blend-mode: screen;
    will-change: transform, opacity;
}

.QuickJournalCyberpunkAmbientMotion__ambientMagenta___xgscC {
    background: linear-gradient(
        112deg,
        transparent 24%,
        rgba(255, 14, 151, 0.1) 47%,
        transparent 72%
    );
    opacity: 0.12;
    animation: QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkAmbientMagenta___icv64 31s ease-in-out -11s
        infinite alternate;
}

.QuickJournalCyberpunkAmbientMotion__ambientCyan___OTQtT {
    background: linear-gradient(
        248deg,
        transparent 26%,
        rgba(0, 217, 239, 0.09) 49%,
        transparent 73%
    );
    opacity: 0.11;
    animation: QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkAmbientCyan___Urct6 37s ease-in-out -23s infinite
        alternate;
}

.QuickJournalCyberpunkAmbientMotion__wetStreet___mDtfg {
    position: absolute;
    left: -7%;
    right: -7%;
    bottom: -4%;
    height: 88%;
    overflow: hidden;
    background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0) 0%,
        rgba(1, 8, 16, 0.1) 22%,
        rgba(0, 1, 5, 0.7) 100%
    );
    mask-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.58) 11%,
        rgb(0, 0, 0) 22%,
        rgb(0, 0, 0) 100%
    );
    -webkit-mask-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.58) 11%,
        rgb(0, 0, 0) 22%,
        rgb(0, 0, 0) 100%
    );
}

.QuickJournalCyberpunkAmbientMotion__streetSurface___p0BSF,
.QuickJournalCyberpunkAmbientMotion__streetBokeh___Thxju,
.QuickJournalCyberpunkAmbientMotion__streetRipple___HK8un,
.QuickJournalCyberpunkAmbientMotion__streetPuddle___ZDXVb {
    display: block;
    position: absolute;
    pointer-events: none;
}

.QuickJournalCyberpunkAmbientMotion__streetSurface___p0BSF {
    inset: 0;
    overflow: hidden;
    background: linear-gradient(
        to bottom,
        rgb(8, 20, 37) 0%,
        rgb(5, 10, 24) 39%,
        rgb(2, 4, 13) 72%,
        rgb(0, 1, 5) 100%
    );
}

.QuickJournalCyberpunkAmbientMotion__streetSurface___p0BSF::before,
.QuickJournalCyberpunkAmbientMotion__streetSurface___p0BSF::after {
    content: "";
    position: absolute;
    pointer-events: none;
}

.QuickJournalCyberpunkAmbientMotion__streetSurface___p0BSF::before {
    inset: -8% -12%;
    background:
        linear-gradient(
            90deg,
            transparent 0%,
            rgba(0, 221, 239, 0.06) 35%,
            rgba(0, 174, 214, 0.13) 52%,
            transparent 100%
        )
        3% 38% / 42% 22% no-repeat,
        linear-gradient(
            90deg,
            transparent 0%,
            rgba(255, 38, 174, 0.05) 34%,
            rgba(255, 38, 174, 0.11) 55%,
            transparent 100%
        )
        46% 61% / 39% 20% no-repeat,
        linear-gradient(
            90deg,
            transparent 0%,
            rgba(255, 170, 97, 0.045) 35%,
            rgba(255, 170, 97, 0.09) 56%,
            transparent 100%
        )
        74% 28% / 30% 18% no-repeat;
    filter: blur(18px);
    mix-blend-mode: screen;
    opacity: 0.9;
    animation: QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkSurfaceShimmer___JVsFs 26s ease-in-out infinite
        alternate;
}

.QuickJournalCyberpunkAmbientMotion__streetSurface___p0BSF::after {
    inset: 0;
    background:
        linear-gradient(
            to bottom,
            transparent 0%,
            transparent 25%,
            rgba(136, 214, 230, 0.022) 26%,
            transparent 30%
        ),
        linear-gradient(
            to bottom,
            transparent 0%,
            transparent 48%,
            rgba(210, 82, 181, 0.018) 49%,
            transparent 54%
        );
    filter: blur(2px);
    opacity: 0.72;
}

.QuickJournalCyberpunkAmbientMotion__streetPuddle___ZDXVb {
    display: block;
    position: absolute;
    width: 112px;
    height: 18px;
    border-radius: 50%;
    background: linear-gradient(
        90deg,
        transparent 0%,
        var(--quickJournalCyberpunkPuddleTint) 24%,
        rgba(213, 255, 255, 0.14) 50%,
        var(--quickJournalCyberpunkPuddleTint) 76%,
        transparent 100%
    );
    box-shadow:
        0 0 18px var(--quickJournalCyberpunkPuddleGlow),
        0 0 34px var(--quickJournalCyberpunkPuddleGlow);
    filter: blur(5px);
    mix-blend-mode: screen;
    opacity: 0.18;
    pointer-events: none;
    transform-origin: center;
    will-change: transform, opacity;
    animation: QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkPuddleSheen___NANlQ 17s ease-in-out infinite;
}

.QuickJournalCyberpunkAmbientMotion__streetPuddle___ZDXVb::after {
    content: "";
    position: absolute;
    left: 20%;
    right: 20%;
    top: 43%;
    height: 2px;
    background: var(--quickJournalCyberpunkPuddleTint);
    filter: blur(1px);
    opacity: 0.65;
}

.QuickJournalCyberpunkAmbientMotion__streetPuddleOne____7yPr {
    --quickJournalCyberpunkPuddleTint: rgba(21, 210, 232, 0.45);
    --quickJournalCyberpunkPuddleGlow: rgba(0, 190, 224, 0.22);
    --quickJournalCyberpunkPuddleAngle: -7deg;
    left: 4%;
    bottom: 18%;
    width: 142px;
    animation-delay: -6s;
}

.QuickJournalCyberpunkAmbientMotion__streetPuddleTwo___FjYch {
    --quickJournalCyberpunkPuddleTint: rgba(244, 43, 175, 0.4);
    --quickJournalCyberpunkPuddleGlow: rgba(230, 24, 163, 0.18);
    --quickJournalCyberpunkPuddleAngle: 8deg;
    left: 34%;
    bottom: 28%;
    width: 92px;
    height: 13px;
    animation-duration: 21s;
    animation-delay: -13s;
}

.QuickJournalCyberpunkAmbientMotion__streetPuddleThree___jxv_j {
    --quickJournalCyberpunkPuddleTint: rgba(31, 205, 233, 0.38);
    --quickJournalCyberpunkPuddleGlow: rgba(0, 173, 222, 0.2);
    --quickJournalCyberpunkPuddleAngle: 5deg;
    right: 1%;
    bottom: 15%;
    width: 184px;
    height: 21px;
    animation-duration: 23s;
    animation-delay: -17s;
}

.QuickJournalCyberpunkAmbientMotion__streetPuddleFour___XYRZa {
    --quickJournalCyberpunkPuddleTint: rgba(255, 165, 91, 0.34);
    --quickJournalCyberpunkPuddleGlow: rgba(246, 127, 72, 0.16);
    --quickJournalCyberpunkPuddleAngle: -4deg;
    left: 59%;
    bottom: 39%;
    width: 74px;
    height: 10px;
    animation-duration: 14s;
    animation-delay: -9s;
}

.QuickJournalCyberpunkAmbientMotion__streetPuddleFive___etaiC {
    --quickJournalCyberpunkPuddleTint: rgba(78, 223, 241, 0.3);
    --quickJournalCyberpunkPuddleGlow: rgba(20, 194, 222, 0.16);
    --quickJournalCyberpunkPuddleAngle: 4deg;
    left: 18%;
    bottom: 47%;
    width: 66px;
    height: 9px;
    animation-duration: 19s;
    animation-delay: -15s;
}

.QuickJournalCyberpunkAmbientMotion__streetPuddleSix___R6TJv {
    --quickJournalCyberpunkPuddleTint: rgba(238, 48, 179, 0.3);
    --quickJournalCyberpunkPuddleGlow: rgba(224, 25, 157, 0.15);
    --quickJournalCyberpunkPuddleAngle: -9deg;
    right: 27%;
    bottom: 33%;
    width: 118px;
    height: 12px;
    animation-duration: 18s;
    animation-delay: -11s;
}

.QuickJournalCyberpunkAmbientMotion__streetBokeh___Thxju {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: var(--quickJournalCyberpunkBokehTint);
    box-shadow:
        0 0 8px var(--quickJournalCyberpunkBokehGlow),
        0 0 20px var(--quickJournalCyberpunkBokehGlow);
    filter: blur(var(--quickJournalCyberpunkBokehBlur));
    mix-blend-mode: screen;
    transform-origin: center;
    will-change: transform, opacity;
    animation: QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkBokehFloat___OYOYB 13s ease-in-out infinite;
}

.QuickJournalCyberpunkAmbientMotion__streetBokehReflection___D8VeF::after {
    content: "";
    position: absolute;
    left: -10%;
    top: 165%;
    width: 120%;
    height: 260%;
    border-radius: 42% 58% 54% 46%;
    background: linear-gradient(
        to bottom,
        var(--quickJournalCyberpunkBokehTint) 0%,
        rgba(0, 0, 0, 0.02) 48%,
        transparent 100%
    );
    box-shadow: 0 0 14px var(--quickJournalCyberpunkBokehGlow);
    filter: blur(calc(var(--quickJournalCyberpunkBokehBlur) + 2px));
    opacity: 0.55;
    transform: scaleY(1.2) skewX(-8deg);
}

.QuickJournalCyberpunkAmbientMotion__streetBokehOne___iuNLz {
    --quickJournalCyberpunkBokehTint: rgba(41, 220, 240, 0.46);
    --quickJournalCyberpunkBokehGlow: rgba(0, 205, 239, 0.25);
    --quickJournalCyberpunkBokehBlur: 4px;
    --quickJournalCyberpunkBokehPeak: 0.72;
    left: 14%;
    top: 19%;
    width: 16px;
    height: 16px;
    animation-duration: 12s;
    animation-delay: -4s;
}

.QuickJournalCyberpunkAmbientMotion__streetBokehTwo___qaePk {
    --quickJournalCyberpunkBokehTint: rgba(255, 48, 174, 0.4);
    --quickJournalCyberpunkBokehGlow: rgba(247, 20, 162, 0.24);
    --quickJournalCyberpunkBokehBlur: 7px;
    --quickJournalCyberpunkBokehPeak: 0.64;
    right: 20%;
    top: 30%;
    width: 25px;
    height: 25px;
    animation-duration: 17s;
    animation-delay: -12s;
}

.QuickJournalCyberpunkAmbientMotion__streetBokehThree___qeZzD {
    --quickJournalCyberpunkBokehTint: rgba(107, 236, 250, 0.48);
    --quickJournalCyberpunkBokehGlow: rgba(23, 201, 231, 0.24);
    --quickJournalCyberpunkBokehBlur: 2px;
    --quickJournalCyberpunkBokehPeak: 0.62;
    left: 45%;
    top: 37%;
    width: 9px;
    height: 9px;
    animation-duration: 10s;
    animation-delay: -6s;
}

.QuickJournalCyberpunkAmbientMotion__streetBokehFour___xKaZ6 {
    --quickJournalCyberpunkBokehTint: rgba(255, 177, 107, 0.42);
    --quickJournalCyberpunkBokehGlow: rgba(255, 140, 72, 0.2);
    --quickJournalCyberpunkBokehBlur: 4px;
    --quickJournalCyberpunkBokehPeak: 0.58;
    left: 35%;
    top: 55%;
    width: 13px;
    height: 13px;
    animation-duration: 15s;
    animation-delay: -9s;
}

.QuickJournalCyberpunkAmbientMotion__streetBokehFive___Klskp {
    --quickJournalCyberpunkBokehTint: rgba(253, 91, 190, 0.38);
    --quickJournalCyberpunkBokehGlow: rgba(222, 29, 154, 0.21);
    --quickJournalCyberpunkBokehBlur: 5px;
    --quickJournalCyberpunkBokehPeak: 0.55;
    left: 6%;
    top: 43%;
    width: 15px;
    height: 15px;
    animation-duration: 19s;
    animation-delay: -15s;
}

.QuickJournalCyberpunkAmbientMotion__streetBokehSix___WTHAt {
    --quickJournalCyberpunkBokehTint: rgba(74, 225, 241, 0.4);
    --quickJournalCyberpunkBokehGlow: rgba(0, 193, 226, 0.23);
    --quickJournalCyberpunkBokehBlur: 8px;
    --quickJournalCyberpunkBokehPeak: 0.58;
    right: 7%;
    top: 51%;
    width: 23px;
    height: 23px;
    animation-duration: 21s;
    animation-delay: -7s;
}

.QuickJournalCyberpunkAmbientMotion__streetBokehSeven___ItNas {
    --quickJournalCyberpunkBokehTint: rgba(255, 191, 113, 0.36);
    --quickJournalCyberpunkBokehGlow: rgba(255, 145, 76, 0.18);
    --quickJournalCyberpunkBokehBlur: 3px;
    --quickJournalCyberpunkBokehPeak: 0.52;
    right: 35%;
    top: 27%;
    width: 8px;
    height: 8px;
    animation-duration: 11s;
    animation-delay: -2s;
}

.QuickJournalCyberpunkAmbientMotion__streetBokehEight___XZwKb {
    --quickJournalCyberpunkBokehTint: rgba(255, 63, 181, 0.34);
    --quickJournalCyberpunkBokehGlow: rgba(230, 25, 161, 0.18);
    --quickJournalCyberpunkBokehBlur: 4px;
    --quickJournalCyberpunkBokehPeak: 0.5;
    left: 62%;
    top: 64%;
    width: 11px;
    height: 11px;
    animation-duration: 14s;
    animation-delay: -11s;
}

.QuickJournalCyberpunkAmbientMotion__streetRipple___HK8un {
    box-sizing: border-box;
    border: 1px solid rgba(137, 212, 232, 0.26);
    border-radius: 50%;
    filter: blur(0.35px);
    opacity: 0.15;
    transform-origin: center;
    will-change: transform, opacity;
    animation: QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkRipple___Ldsic 12s ease-out infinite;
}

.QuickJournalCyberpunkAmbientMotion__streetRippleOne___uBNtR {
    left: 29%;
    bottom: 22%;
    width: 48px;
    height: 11px;
    animation-duration: 11s;
    animation-delay: -2s;
}

.QuickJournalCyberpunkAmbientMotion__streetRippleTwo___Vf7i9 {
    right: 20%;
    bottom: 15%;
    width: 32px;
    height: 8px;
    border-color: rgba(255, 100, 196, 0.18);
    animation-duration: 15s;
    animation-delay: -8s;
}

.QuickJournalCyberpunkAmbientMotion__streetRippleThree___t4cxU {
    left: 58%;
    bottom: 37%;
    width: 24px;
    height: 6px;
    border-color: rgba(150, 223, 255, 0.16);
    animation-duration: 13s;
    animation-delay: -11s;
}

@keyframes QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkAmbientMagenta___icv64 {
    0% {
        opacity: 0.08;
        transform: translate3d(-4%, 2%, 0) scale(1);
    }

    52% {
        opacity: 0.14;
    }

    100% {
        opacity: 0.1;
        transform: translate3d(5%, -2%, 0) scale(1.035);
    }
}

@keyframes QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkAmbientCyan___Urct6 {
    0% {
        opacity: 0.08;
        transform: translate3d(4%, -1%, 0) scale(1.02);
    }

    48% {
        opacity: 0.13;
    }

    100% {
        opacity: 0.09;
        transform: translate3d(-5%, 2%, 0) scale(1);
    }
}

@keyframes QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkBokehFloat___OYOYB {
    0% {
        opacity: 0;
        transform: translate3d(-5px, 3px, 0) scale(0.78);
    }

    24% {
        opacity: var(--quickJournalCyberpunkBokehPeak);
    }

    58% {
        opacity: calc(var(--quickJournalCyberpunkBokehPeak) * 0.78);
        transform: translate3d(3px, -2px, 0) scale(1.05);
    }

    100% {
        opacity: 0;
        transform: translate3d(8px, 2px, 0) scale(0.86);
    }
}

@keyframes QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkSurfaceShimmer___JVsFs {
    0% {
        opacity: 0.52;
        transform: translate3d(-2%, 1%, 0) scale(1);
    }

    52% {
        opacity: 0.78;
    }

    100% {
        opacity: 0.62;
        transform: translate3d(3%, -1%, 0) scale(1.04);
    }
}

@keyframes QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkPuddleSheen___NANlQ {
    0%,
    100% {
        opacity: 0.1;
        transform: translate3d(-9px, 3px, 0) rotate(var(--quickJournalCyberpunkPuddleAngle, 0deg)) scaleX(0.82);
    }

    38% {
        opacity: 0.34;
        transform: translate3d(5px, -2px, 0) rotate(var(--quickJournalCyberpunkPuddleAngle, 0deg)) scaleX(1.08);
    }

    68% {
        opacity: 0.2;
        transform: translate3d(12px, 1px, 0) rotate(var(--quickJournalCyberpunkPuddleAngle, 0deg)) scaleX(0.94);
    }
}

@keyframes QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkRipple___Ldsic {
    0% {
        opacity: 0;
        transform: scale(0.58);
    }

    22% {
        opacity: 0.34;
    }

    100% {
        opacity: 0;
        transform: scale(1.7);
    }
}

@media (prefers-reduced-motion: reduce) {
    .QuickJournalCyberpunkAmbientMotion__ambient___QPEJj,
    .QuickJournalCyberpunkAmbientMotion__streetBokeh___Thxju,
    .QuickJournalCyberpunkAmbientMotion__streetRipple___HK8un,
    .QuickJournalCyberpunkAmbientMotion__streetPuddle___ZDXVb,
    .QuickJournalCyberpunkAmbientMotion__streetSurface___p0BSF::before {
        animation: none;
    }

    .QuickJournalCyberpunkAmbientMotion__ambient___QPEJj {
        opacity: 0.07;
    }

    .QuickJournalCyberpunkAmbientMotion__streetBokeh___Thxju {
        opacity: 0.22;
    }

    .QuickJournalCyberpunkAmbientMotion__streetRipple___HK8un {
        opacity: 0.08;
    }

    .QuickJournalCyberpunkAmbientMotion__streetPuddle___ZDXVb {
        opacity: 0.12;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QuickJournalCyberpunkAmbientMotion__container___X8kOW`,
	"ambient": `QuickJournalCyberpunkAmbientMotion__ambient___QPEJj`,
	"ambientMagenta": `QuickJournalCyberpunkAmbientMotion__ambientMagenta___xgscC`,
	"quickJournalCyberpunkAmbientMagenta": `QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkAmbientMagenta___icv64`,
	"ambientCyan": `QuickJournalCyberpunkAmbientMotion__ambientCyan___OTQtT`,
	"quickJournalCyberpunkAmbientCyan": `QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkAmbientCyan___Urct6`,
	"wetStreet": `QuickJournalCyberpunkAmbientMotion__wetStreet___mDtfg`,
	"streetSurface": `QuickJournalCyberpunkAmbientMotion__streetSurface___p0BSF`,
	"streetBokeh": `QuickJournalCyberpunkAmbientMotion__streetBokeh___Thxju`,
	"streetRipple": `QuickJournalCyberpunkAmbientMotion__streetRipple___HK8un`,
	"streetPuddle": `QuickJournalCyberpunkAmbientMotion__streetPuddle___ZDXVb`,
	"quickJournalCyberpunkSurfaceShimmer": `QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkSurfaceShimmer___JVsFs`,
	"quickJournalCyberpunkPuddleSheen": `QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkPuddleSheen___NANlQ`,
	"streetPuddleOne": `QuickJournalCyberpunkAmbientMotion__streetPuddleOne____7yPr`,
	"streetPuddleTwo": `QuickJournalCyberpunkAmbientMotion__streetPuddleTwo___FjYch`,
	"streetPuddleThree": `QuickJournalCyberpunkAmbientMotion__streetPuddleThree___jxv_j`,
	"streetPuddleFour": `QuickJournalCyberpunkAmbientMotion__streetPuddleFour___XYRZa`,
	"streetPuddleFive": `QuickJournalCyberpunkAmbientMotion__streetPuddleFive___etaiC`,
	"streetPuddleSix": `QuickJournalCyberpunkAmbientMotion__streetPuddleSix___R6TJv`,
	"quickJournalCyberpunkBokehFloat": `QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkBokehFloat___OYOYB`,
	"streetBokehReflection": `QuickJournalCyberpunkAmbientMotion__streetBokehReflection___D8VeF`,
	"streetBokehOne": `QuickJournalCyberpunkAmbientMotion__streetBokehOne___iuNLz`,
	"streetBokehTwo": `QuickJournalCyberpunkAmbientMotion__streetBokehTwo___qaePk`,
	"streetBokehThree": `QuickJournalCyberpunkAmbientMotion__streetBokehThree___qeZzD`,
	"streetBokehFour": `QuickJournalCyberpunkAmbientMotion__streetBokehFour___xKaZ6`,
	"streetBokehFive": `QuickJournalCyberpunkAmbientMotion__streetBokehFive___Klskp`,
	"streetBokehSix": `QuickJournalCyberpunkAmbientMotion__streetBokehSix___WTHAt`,
	"streetBokehSeven": `QuickJournalCyberpunkAmbientMotion__streetBokehSeven___ItNas`,
	"streetBokehEight": `QuickJournalCyberpunkAmbientMotion__streetBokehEight___XZwKb`,
	"quickJournalCyberpunkRipple": `QuickJournalCyberpunkAmbientMotion__quickJournalCyberpunkRipple___Ldsic`,
	"streetRippleOne": `QuickJournalCyberpunkAmbientMotion__streetRippleOne___uBNtR`,
	"streetRippleTwo": `QuickJournalCyberpunkAmbientMotion__streetRippleTwo___Vf7i9`,
	"streetRippleThree": `QuickJournalCyberpunkAmbientMotion__streetRippleThree___t4cxU`
};
module.exports = ___CSS_LOADER_EXPORT___;
